<div class="pagination">
  <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="setCurrentPage($event)">
    <ul class="custom-pagination pagination">
      <li class="pagination-previous" [class.circle]="!!circle" [class.disabled]="p.isFirstPage()" *ngIf="!!p.pages"
        (click)="previousPage(p.isFirstPage())">
        <a *ngIf="!prevIconSrc"> &laquo; Previous </a>
        <a *ngIf="prevIconSrc">
          <img [src]="prevIconSrc">
        </a>
      </li>
      <li *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value">
        <a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
          <span>{{ page.label }}</span>
        </a>
        <a *ngIf="p.getCurrent() === page.value">
          <span>{{ page.label }}</span>
        </a>
      </li>
      <li class="pagination-next" [class.circle]="!!circle" [class.disabled]="p.isLastPage()" *ngIf="!!p.pages"
        (click)="nextPage(p.isLastPage())">
        <a *ngIf="!nextIconSrc"> Next &raquo; </a>
        <a *ngIf="nextIconSrc">
          <img [src]="nextIconSrc">
        </a>
      </li>
    </ul>
  </pagination-template>
</div>